import { ColorOptions, Icon, IconOptions } from '@jfs/ui-new'
import { defaultColors } from '@jfs/ui-new/src/theme/DefaultTheme'
import { ModBox } from '../ModifiedBox/ModifiedBox'

interface onPress {
  filterData: () => void
}

export const FilterComp = (onPress: onPress) => {
  return iconButton('FILTER', onPress?.filterData)
}

const iconButton = (id: string, setFilterVisible: () => void) => {
  return (
    <ModBox
      underlayColor="WHITE"
      testID={'filter-' + id}
      onPress={() => setFilterVisible()}
      bg={defaultColors.WHITE as ColorOptions}>
      <Icon id={id as IconOptions} color="BLUE" size={22} />
    </ModBox>
  )
}
